import React from 'react';
import MukurtamPage from './components/MukurtamPage';

function App() {
  return <MukurtamPage />;
}

export default App;
